"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * guest-experience-api
 * Public service that provides the endpoints used by the users in the shopping experience
 *
 * The version of the OpenAPI document: 1.0.15
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationApiFp = exports.LocationApiAxiosParamCreator = exports.HostedWidgetApi = exports.HostedWidgetApiFactory = exports.HostedWidgetApiFp = exports.HostedWidgetApiAxiosParamCreator = exports.GiftCardProductApi = exports.GiftCardProductApiFactory = exports.GiftCardProductApiFp = exports.GiftCardProductApiAxiosParamCreator = exports.FormFieldApi = exports.FormFieldApiFactory = exports.FormFieldApiFp = exports.FormFieldApiAxiosParamCreator = exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.CustomerApi = exports.CustomerApiFactory = exports.CustomerApiFp = exports.CustomerApiAxiosParamCreator = exports.FindAllSortEnum = exports.CategoryApi = exports.CategoryApiFactory = exports.CategoryApiFp = exports.CategoryApiAxiosParamCreator = exports.CartApi = exports.CartApiFactory = exports.CartApiFp = exports.CartApiAxiosParamCreator = exports.AvailabilityApi = exports.AvailabilityApiFactory = exports.AvailabilityApiFp = exports.AvailabilityApiAxiosParamCreator = exports.UpsellDateSpanSettingsDtoEndDateReferenceEnum = exports.UpsellDateSpanSettingsDtoStartDateReferenceEnum = exports.UpsellConfigurationDtoAttachmentTypeEnum = exports.UpsellConfigurationDtoDateRestrictionEnum = exports.TimeslotTypeDisplayDtoTypeEnum = exports.LabelTypeDto = exports.FilterAttributeDtoTypeEnum = exports.FilterAttributeCodeDto = exports.DurationDtoUnitEnum = exports.DetailProductDtoAllocationTypeEnum = exports.DetailGiftCardProductDtoPriceTypeEnum = exports.DetailGiftCardProductDtoEndDateTypeEnum = exports.DetailGiftCardProductDtoStartDateTypeEnum = exports.DetailGiftCardProductDtoAllocationTypeEnum = exports.CompanyEcommercePaymentProviderDtoIdEnum = void 0;
exports.ProductApi = exports.ProductApiFactory = exports.ProductApiFp = exports.ProductApiAxiosParamCreator = exports.LocationApi = exports.LocationApiFactory = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
    * @export
    * @enum {string}
    */
var CompanyEcommercePaymentProviderDtoIdEnum;
(function (CompanyEcommercePaymentProviderDtoIdEnum) {
    CompanyEcommercePaymentProviderDtoIdEnum["CheckfrontPayments"] = "CheckfrontPayments";
    CompanyEcommercePaymentProviderDtoIdEnum["NextGenPay"] = "NextGenPay";
    CompanyEcommercePaymentProviderDtoIdEnum["None"] = "None";
})(CompanyEcommercePaymentProviderDtoIdEnum = exports.CompanyEcommercePaymentProviderDtoIdEnum || (exports.CompanyEcommercePaymentProviderDtoIdEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DetailGiftCardProductDtoAllocationTypeEnum;
(function (DetailGiftCardProductDtoAllocationTypeEnum) {
    DetailGiftCardProductDtoAllocationTypeEnum["Day"] = "day";
    DetailGiftCardProductDtoAllocationTypeEnum["Night"] = "night";
    DetailGiftCardProductDtoAllocationTypeEnum["Flextime"] = "flextime";
    DetailGiftCardProductDtoAllocationTypeEnum["Timeslot"] = "timeslot";
})(DetailGiftCardProductDtoAllocationTypeEnum = exports.DetailGiftCardProductDtoAllocationTypeEnum || (exports.DetailGiftCardProductDtoAllocationTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DetailGiftCardProductDtoStartDateTypeEnum;
(function (DetailGiftCardProductDtoStartDateTypeEnum) {
    DetailGiftCardProductDtoStartDateTypeEnum["Purchase"] = "purchase";
    DetailGiftCardProductDtoStartDateTypeEnum["Fixed"] = "fixed";
    DetailGiftCardProductDtoStartDateTypeEnum["Delivery"] = "delivery";
})(DetailGiftCardProductDtoStartDateTypeEnum = exports.DetailGiftCardProductDtoStartDateTypeEnum || (exports.DetailGiftCardProductDtoStartDateTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DetailGiftCardProductDtoEndDateTypeEnum;
(function (DetailGiftCardProductDtoEndDateTypeEnum) {
    DetailGiftCardProductDtoEndDateTypeEnum["Never"] = "never";
    DetailGiftCardProductDtoEndDateTypeEnum["Fixed"] = "fixed";
    DetailGiftCardProductDtoEndDateTypeEnum["Duration"] = "duration";
})(DetailGiftCardProductDtoEndDateTypeEnum = exports.DetailGiftCardProductDtoEndDateTypeEnum || (exports.DetailGiftCardProductDtoEndDateTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DetailGiftCardProductDtoPriceTypeEnum;
(function (DetailGiftCardProductDtoPriceTypeEnum) {
    DetailGiftCardProductDtoPriceTypeEnum["Allocation"] = "allocation";
    DetailGiftCardProductDtoPriceTypeEnum["Fixed"] = "fixed";
    DetailGiftCardProductDtoPriceTypeEnum["_24H"] = "24H";
})(DetailGiftCardProductDtoPriceTypeEnum = exports.DetailGiftCardProductDtoPriceTypeEnum || (exports.DetailGiftCardProductDtoPriceTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DetailProductDtoAllocationTypeEnum;
(function (DetailProductDtoAllocationTypeEnum) {
    DetailProductDtoAllocationTypeEnum["Day"] = "day";
    DetailProductDtoAllocationTypeEnum["Night"] = "night";
    DetailProductDtoAllocationTypeEnum["Flextime"] = "flextime";
    DetailProductDtoAllocationTypeEnum["Timeslot"] = "timeslot";
})(DetailProductDtoAllocationTypeEnum = exports.DetailProductDtoAllocationTypeEnum || (exports.DetailProductDtoAllocationTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DurationDtoUnitEnum;
(function (DurationDtoUnitEnum) {
    DurationDtoUnitEnum["Minute"] = "Minute";
    DurationDtoUnitEnum["Hour"] = "Hour";
    DurationDtoUnitEnum["Day"] = "Day";
    DurationDtoUnitEnum["Night"] = "Night";
    DurationDtoUnitEnum["Week"] = "Week";
    DurationDtoUnitEnum["Month"] = "Month";
    DurationDtoUnitEnum["Year"] = "Year";
})(DurationDtoUnitEnum = exports.DurationDtoUnitEnum || (exports.DurationDtoUnitEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var FilterAttributeCodeDto;
(function (FilterAttributeCodeDto) {
    FilterAttributeCodeDto["Tags"] = "tags";
    FilterAttributeCodeDto["Categories"] = "categories";
    FilterAttributeCodeDto["Price"] = "price";
    FilterAttributeCodeDto["Languages"] = "languages";
    FilterAttributeCodeDto["TopThingsToDo"] = "topThingsToDo";
    FilterAttributeCodeDto["Weather"] = "weather";
    FilterAttributeCodeDto["SuitableFor"] = "suitableFor";
})(FilterAttributeCodeDto = exports.FilterAttributeCodeDto || (exports.FilterAttributeCodeDto = {}));
/**
    * @export
    * @enum {string}
    */
var FilterAttributeDtoTypeEnum;
(function (FilterAttributeDtoTypeEnum) {
    FilterAttributeDtoTypeEnum["Category"] = "category";
    FilterAttributeDtoTypeEnum["Tag"] = "tag";
})(FilterAttributeDtoTypeEnum = exports.FilterAttributeDtoTypeEnum || (exports.FilterAttributeDtoTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var LabelTypeDto;
(function (LabelTypeDto) {
    LabelTypeDto["SaleEnded"] = "sale-ended";
    LabelTypeDto["SoldOut"] = "sold-out";
    LabelTypeDto["New"] = "new";
    LabelTypeDto["Bestseller"] = "bestseller";
})(LabelTypeDto = exports.LabelTypeDto || (exports.LabelTypeDto = {}));
/**
    * @export
    * @enum {string}
    */
var TimeslotTypeDisplayDtoTypeEnum;
(function (TimeslotTypeDisplayDtoTypeEnum) {
    TimeslotTypeDisplayDtoTypeEnum["Buttons"] = "buttons";
    TimeslotTypeDisplayDtoTypeEnum["Dropdown"] = "dropdown";
})(TimeslotTypeDisplayDtoTypeEnum = exports.TimeslotTypeDisplayDtoTypeEnum || (exports.TimeslotTypeDisplayDtoTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UpsellConfigurationDtoDateRestrictionEnum;
(function (UpsellConfigurationDtoDateRestrictionEnum) {
    UpsellConfigurationDtoDateRestrictionEnum["Unrestricted"] = "unrestricted";
    UpsellConfigurationDtoDateRestrictionEnum["UseParentDates"] = "useParentDates";
    UpsellConfigurationDtoDateRestrictionEnum["SelectWithinParentDates"] = "selectWithinParentDates";
    UpsellConfigurationDtoDateRestrictionEnum["Custom"] = "custom";
})(UpsellConfigurationDtoDateRestrictionEnum = exports.UpsellConfigurationDtoDateRestrictionEnum || (exports.UpsellConfigurationDtoDateRestrictionEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UpsellConfigurationDtoAttachmentTypeEnum;
(function (UpsellConfigurationDtoAttachmentTypeEnum) {
    UpsellConfigurationDtoAttachmentTypeEnum["Optional"] = "optional";
    UpsellConfigurationDtoAttachmentTypeEnum["Preselected"] = "preselected";
    UpsellConfigurationDtoAttachmentTypeEnum["Required"] = "required";
})(UpsellConfigurationDtoAttachmentTypeEnum = exports.UpsellConfigurationDtoAttachmentTypeEnum || (exports.UpsellConfigurationDtoAttachmentTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UpsellDateSpanSettingsDtoStartDateReferenceEnum;
(function (UpsellDateSpanSettingsDtoStartDateReferenceEnum) {
    UpsellDateSpanSettingsDtoStartDateReferenceEnum["ParentStartDate"] = "parentStartDate";
    UpsellDateSpanSettingsDtoStartDateReferenceEnum["ParentEndDate"] = "parentEndDate";
})(UpsellDateSpanSettingsDtoStartDateReferenceEnum = exports.UpsellDateSpanSettingsDtoStartDateReferenceEnum || (exports.UpsellDateSpanSettingsDtoStartDateReferenceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UpsellDateSpanSettingsDtoEndDateReferenceEnum;
(function (UpsellDateSpanSettingsDtoEndDateReferenceEnum) {
    UpsellDateSpanSettingsDtoEndDateReferenceEnum["ParentStartDate"] = "parentStartDate";
    UpsellDateSpanSettingsDtoEndDateReferenceEnum["ParentEndDate"] = "parentEndDate";
})(UpsellDateSpanSettingsDtoEndDateReferenceEnum = exports.UpsellDateSpanSettingsDtoEndDateReferenceEnum || (exports.UpsellDateSpanSettingsDtoEndDateReferenceEnum = {}));
/**
 * AvailabilityApi - axios parameter creator
 * @export
 */
const AvailabilityApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {any} [lang] Locale for content translation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (xPartnerCode, lang, options = {}) => {
            // verify required parameter 'xPartnerCode' is not null or undefined
            (0, common_1.assertParamExists)('findAll', 'xPartnerCode', xPartnerCode);
            const localVarPath = `/v1/availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (lang !== undefined) {
                for (const [key, value] of Object.entries(lang)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (xPartnerCode != null) {
                localVarHeaderParameter['x-partner-code'] = String(xPartnerCode);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {any} [lang] Locale for content translation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll_1: async (xPartnerCode, lang, options = {}) => {
            // verify required parameter 'xPartnerCode' is not null or undefined
            (0, common_1.assertParamExists)('findAll_1', 'xPartnerCode', xPartnerCode);
            const localVarPath = `/v1/upsells/availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (lang !== undefined) {
                for (const [key, value] of Object.entries(lang)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (xPartnerCode != null) {
                localVarHeaderParameter['x-partner-code'] = String(xPartnerCode);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AvailabilityApiAxiosParamCreator = AvailabilityApiAxiosParamCreator;
/**
 * AvailabilityApi - functional programming interface
 * @export
 */
const AvailabilityApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AvailabilityApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {any} [lang] Locale for content translation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(xPartnerCode, lang, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(xPartnerCode, lang, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AvailabilityApi.findAll']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {any} [lang] Locale for content translation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll_1(xPartnerCode, lang, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll_1(xPartnerCode, lang, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AvailabilityApi.findAll_1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.AvailabilityApiFp = AvailabilityApiFp;
/**
 * AvailabilityApi - factory interface
 * @export
 */
const AvailabilityApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AvailabilityApiFp)(configuration);
    return {
        /**
         *
         * @param {AvailabilityApiFindAllRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(requestParameters, options) {
            return localVarFp.findAll(requestParameters.xPartnerCode, requestParameters.lang, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AvailabilityApiFindAll0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll_1(requestParameters, options) {
            return localVarFp.findAll_1(requestParameters.xPartnerCode, requestParameters.lang, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AvailabilityApiFactory = AvailabilityApiFactory;
/**
 * AvailabilityApi - object-oriented interface
 * @export
 * @class AvailabilityApi
 * @extends {BaseAPI}
 */
class AvailabilityApi extends base_1.BaseAPI {
    /**
     *
     * @param {AvailabilityApiFindAllRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailabilityApi
     */
    findAll(requestParameters, options) {
        return (0, exports.AvailabilityApiFp)(this.configuration).findAll(requestParameters.xPartnerCode, requestParameters.lang, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AvailabilityApiFindAll0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailabilityApi
     */
    findAll_1(requestParameters, options) {
        return (0, exports.AvailabilityApiFp)(this.configuration).findAll_1(requestParameters.xPartnerCode, requestParameters.lang, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AvailabilityApi = AvailabilityApi;
/**
 * CartApi - axios parameter creator
 * @export
 */
const CartApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {CartValidateRequestDto} cartValidateRequestDto
         * @param {any} [lang] Locale for content translation
         * @param {Array<string>} [_with]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate: async (xPartnerCode, cartValidateRequestDto, lang, _with, options = {}) => {
            // verify required parameter 'xPartnerCode' is not null or undefined
            (0, common_1.assertParamExists)('validate', 'xPartnerCode', xPartnerCode);
            // verify required parameter 'cartValidateRequestDto' is not null or undefined
            (0, common_1.assertParamExists)('validate', 'cartValidateRequestDto', cartValidateRequestDto);
            const localVarPath = `/v1/cart/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (lang !== undefined) {
                for (const [key, value] of Object.entries(lang)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (_with) {
                localVarQueryParameter['with'] = _with;
            }
            if (xPartnerCode != null) {
                localVarHeaderParameter['x-partner-code'] = String(xPartnerCode);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cartValidateRequestDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CartApiAxiosParamCreator = CartApiAxiosParamCreator;
/**
 * CartApi - functional programming interface
 * @export
 */
const CartApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CartApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {CartValidateRequestDto} cartValidateRequestDto
         * @param {any} [lang] Locale for content translation
         * @param {Array<string>} [_with]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validate(xPartnerCode, cartValidateRequestDto, lang, _with, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.validate(xPartnerCode, cartValidateRequestDto, lang, _with, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CartApi.validate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.CartApiFp = CartApiFp;
/**
 * CartApi - factory interface
 * @export
 */
const CartApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CartApiFp)(configuration);
    return {
        /**
         *
         * @param {CartApiValidateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate(requestParameters, options) {
            return localVarFp.validate(requestParameters.xPartnerCode, requestParameters.cartValidateRequestDto, requestParameters.lang, requestParameters._with, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CartApiFactory = CartApiFactory;
/**
 * CartApi - object-oriented interface
 * @export
 * @class CartApi
 * @extends {BaseAPI}
 */
class CartApi extends base_1.BaseAPI {
    /**
     *
     * @param {CartApiValidateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartApi
     */
    validate(requestParameters, options) {
        return (0, exports.CartApiFp)(this.configuration).validate(requestParameters.xPartnerCode, requestParameters.cartValidateRequestDto, requestParameters.lang, requestParameters._with, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CartApi = CartApi;
/**
 * CategoryApi - axios parameter creator
 * @export
 */
const CategoryApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {any} [lang] Locale for content translation
         * @param {number} [offset] The number of categories you wish to skip before selecting. Default 0
         * @param {number} [limit] The maximum number of categories that are returned after the offset.
         * @param {FindAllSortEnum} [sort]
         * @param {boolean} [populated] When true, will return categories that has at least one product. Default false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (xPartnerCode, lang, offset, limit, sort, populated, options = {}) => {
            // verify required parameter 'xPartnerCode' is not null or undefined
            (0, common_1.assertParamExists)('findAll', 'xPartnerCode', xPartnerCode);
            const localVarPath = `/v1/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (lang !== undefined) {
                for (const [key, value] of Object.entries(lang)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (populated !== undefined) {
                localVarQueryParameter['populated'] = populated;
            }
            if (xPartnerCode != null) {
                localVarHeaderParameter['x-partner-code'] = String(xPartnerCode);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CategoryApiAxiosParamCreator = CategoryApiAxiosParamCreator;
/**
 * CategoryApi - functional programming interface
 * @export
 */
const CategoryApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CategoryApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {any} [lang] Locale for content translation
         * @param {number} [offset] The number of categories you wish to skip before selecting. Default 0
         * @param {number} [limit] The maximum number of categories that are returned after the offset.
         * @param {FindAllSortEnum} [sort]
         * @param {boolean} [populated] When true, will return categories that has at least one product. Default false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(xPartnerCode, lang, offset, limit, sort, populated, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(xPartnerCode, lang, offset, limit, sort, populated, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CategoryApi.findAll']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.CategoryApiFp = CategoryApiFp;
/**
 * CategoryApi - factory interface
 * @export
 */
const CategoryApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CategoryApiFp)(configuration);
    return {
        /**
         *
         * @param {CategoryApiFindAllRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(requestParameters, options) {
            return localVarFp.findAll(requestParameters.xPartnerCode, requestParameters.lang, requestParameters.offset, requestParameters.limit, requestParameters.sort, requestParameters.populated, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CategoryApiFactory = CategoryApiFactory;
/**
 * CategoryApi - object-oriented interface
 * @export
 * @class CategoryApi
 * @extends {BaseAPI}
 */
class CategoryApi extends base_1.BaseAPI {
    /**
     *
     * @param {CategoryApiFindAllRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    findAll(requestParameters, options) {
        return (0, exports.CategoryApiFp)(this.configuration).findAll(requestParameters.xPartnerCode, requestParameters.lang, requestParameters.offset, requestParameters.limit, requestParameters.sort, requestParameters.populated, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CategoryApi = CategoryApi;
/**
  * @export
  * @enum {string}
  */
var FindAllSortEnum;
(function (FindAllSortEnum) {
    FindAllSortEnum["Name"] = "name";
    FindAllSortEnum["Name2"] = "-name";
})(FindAllSortEnum = exports.FindAllSortEnum || (exports.FindAllSortEnum = {}));
/**
 * CustomerApi - axios parameter creator
 * @export
 */
const CustomerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiDomainByCustomerCode: async (xPartnerCode, options = {}) => {
            // verify required parameter 'xPartnerCode' is not null or undefined
            (0, common_1.assertParamExists)('getApiDomainByCustomerCode', 'xPartnerCode', xPartnerCode);
            const localVarPath = `/v1/customer/api-domain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xPartnerCode != null) {
                localVarHeaderParameter['x-partner-code'] = String(xPartnerCode);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyPlatform: async (xPartnerCode, options = {}) => {
            // verify required parameter 'xPartnerCode' is not null or undefined
            (0, common_1.assertParamExists)('getCompanyPlatform', 'xPartnerCode', xPartnerCode);
            const localVarPath = `/v1/customer/platform`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xPartnerCode != null) {
                localVarHeaderParameter['x-partner-code'] = String(xPartnerCode);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHostedWidgetDomain: async (xPartnerCode, options = {}) => {
            // verify required parameter 'xPartnerCode' is not null or undefined
            (0, common_1.assertParamExists)('getHostedWidgetDomain', 'xPartnerCode', xPartnerCode);
            const localVarPath = `/v1/customer/hosted-widget-domain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xPartnerCode != null) {
                localVarHeaderParameter['x-partner-code'] = String(xPartnerCode);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CustomerApiAxiosParamCreator = CustomerApiAxiosParamCreator;
/**
 * CustomerApi - functional programming interface
 * @export
 */
const CustomerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CustomerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiDomainByCustomerCode(xPartnerCode, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiDomainByCustomerCode(xPartnerCode, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerApi.getApiDomainByCustomerCode']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyPlatform(xPartnerCode, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyPlatform(xPartnerCode, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerApi.getCompanyPlatform']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHostedWidgetDomain(xPartnerCode, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHostedWidgetDomain(xPartnerCode, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerApi.getHostedWidgetDomain']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.CustomerApiFp = CustomerApiFp;
/**
 * CustomerApi - factory interface
 * @export
 */
const CustomerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CustomerApiFp)(configuration);
    return {
        /**
         *
         * @param {CustomerApiGetApiDomainByCustomerCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiDomainByCustomerCode(requestParameters, options) {
            return localVarFp.getApiDomainByCustomerCode(requestParameters.xPartnerCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CustomerApiGetCompanyPlatformRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyPlatform(requestParameters, options) {
            return localVarFp.getCompanyPlatform(requestParameters.xPartnerCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CustomerApiGetHostedWidgetDomainRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHostedWidgetDomain(requestParameters, options) {
            return localVarFp.getHostedWidgetDomain(requestParameters.xPartnerCode, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CustomerApiFactory = CustomerApiFactory;
/**
 * CustomerApi - object-oriented interface
 * @export
 * @class CustomerApi
 * @extends {BaseAPI}
 */
class CustomerApi extends base_1.BaseAPI {
    /**
     *
     * @param {CustomerApiGetApiDomainByCustomerCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    getApiDomainByCustomerCode(requestParameters, options) {
        return (0, exports.CustomerApiFp)(this.configuration).getApiDomainByCustomerCode(requestParameters.xPartnerCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CustomerApiGetCompanyPlatformRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    getCompanyPlatform(requestParameters, options) {
        return (0, exports.CustomerApiFp)(this.configuration).getCompanyPlatform(requestParameters.xPartnerCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CustomerApiGetHostedWidgetDomainRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    getHostedWidgetDomain(requestParameters, options) {
        return (0, exports.CustomerApiFp)(this.configuration).getHostedWidgetDomain(requestParameters.xPartnerCode, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CustomerApi = CustomerApi;
/**
 * DefaultApi - axios parameter creator
 * @export
 */
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveness: async (options = {}) => {
            const localVarPath = `/livez`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readiness: async (options = {}) => {
            const localVarPath = `/readyz`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async liveness(options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.liveness(options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.liveness']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readiness(options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.readiness(options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.readiness']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveness(options) {
            return localVarFp.liveness(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readiness(options) {
            return localVarFp.readiness(options).then((request) => request(axios, basePath));
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    liveness(options) {
        return (0, exports.DefaultApiFp)(this.configuration).liveness(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    readiness(options) {
        return (0, exports.DefaultApiFp)(this.configuration).readiness(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
/**
 * FormFieldApi - axios parameter creator
 * @export
 */
const FormFieldApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {object} body
         * @param {any} [lang] Locale for content translation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (xPartnerCode, body, lang, options = {}) => {
            // verify required parameter 'xPartnerCode' is not null or undefined
            (0, common_1.assertParamExists)('findAll', 'xPartnerCode', xPartnerCode);
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('findAll', 'body', body);
            const localVarPath = `/v1/form-fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (lang !== undefined) {
                for (const [key, value] of Object.entries(lang)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (xPartnerCode != null) {
                localVarHeaderParameter['x-partner-code'] = String(xPartnerCode);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.FormFieldApiAxiosParamCreator = FormFieldApiAxiosParamCreator;
/**
 * FormFieldApi - functional programming interface
 * @export
 */
const FormFieldApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.FormFieldApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {object} body
         * @param {any} [lang] Locale for content translation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(xPartnerCode, body, lang, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(xPartnerCode, body, lang, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FormFieldApi.findAll']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.FormFieldApiFp = FormFieldApiFp;
/**
 * FormFieldApi - factory interface
 * @export
 */
const FormFieldApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.FormFieldApiFp)(configuration);
    return {
        /**
         *
         * @param {FormFieldApiFindAllRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(requestParameters, options) {
            return localVarFp.findAll(requestParameters.xPartnerCode, requestParameters.body, requestParameters.lang, options).then((request) => request(axios, basePath));
        },
    };
};
exports.FormFieldApiFactory = FormFieldApiFactory;
/**
 * FormFieldApi - object-oriented interface
 * @export
 * @class FormFieldApi
 * @extends {BaseAPI}
 */
class FormFieldApi extends base_1.BaseAPI {
    /**
     *
     * @param {FormFieldApiFindAllRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormFieldApi
     */
    findAll(requestParameters, options) {
        return (0, exports.FormFieldApiFp)(this.configuration).findAll(requestParameters.xPartnerCode, requestParameters.body, requestParameters.lang, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.FormFieldApi = FormFieldApi;
/**
 * GiftCardProductApi - axios parameter creator
 * @export
 */
const GiftCardProductApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {string} id
         * @param {any} [lang] Locale for content translation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (xPartnerCode, id, lang, options = {}) => {
            // verify required parameter 'xPartnerCode' is not null or undefined
            (0, common_1.assertParamExists)('findOne', 'xPartnerCode', xPartnerCode);
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('findOne', 'id', id);
            const localVarPath = `/v1/giftcard-products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (lang !== undefined) {
                for (const [key, value] of Object.entries(lang)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (xPartnerCode != null) {
                localVarHeaderParameter['x-partner-code'] = String(xPartnerCode);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.GiftCardProductApiAxiosParamCreator = GiftCardProductApiAxiosParamCreator;
/**
 * GiftCardProductApi - functional programming interface
 * @export
 */
const GiftCardProductApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.GiftCardProductApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {string} id
         * @param {any} [lang] Locale for content translation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(xPartnerCode, id, lang, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(xPartnerCode, id, lang, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GiftCardProductApi.findOne']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.GiftCardProductApiFp = GiftCardProductApiFp;
/**
 * GiftCardProductApi - factory interface
 * @export
 */
const GiftCardProductApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.GiftCardProductApiFp)(configuration);
    return {
        /**
         *
         * @param {GiftCardProductApiFindOneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(requestParameters, options) {
            return localVarFp.findOne(requestParameters.xPartnerCode, requestParameters.id, requestParameters.lang, options).then((request) => request(axios, basePath));
        },
    };
};
exports.GiftCardProductApiFactory = GiftCardProductApiFactory;
/**
 * GiftCardProductApi - object-oriented interface
 * @export
 * @class GiftCardProductApi
 * @extends {BaseAPI}
 */
class GiftCardProductApi extends base_1.BaseAPI {
    /**
     *
     * @param {GiftCardProductApiFindOneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GiftCardProductApi
     */
    findOne(requestParameters, options) {
        return (0, exports.GiftCardProductApiFp)(this.configuration).findOne(requestParameters.xPartnerCode, requestParameters.id, requestParameters.lang, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.GiftCardProductApi = GiftCardProductApi;
/**
 * HostedWidgetApi - axios parameter creator
 * @export
 */
const HostedWidgetApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} subdomainAndRegion Subdomain and region separated by hyphen
         * @param {string} id Widget ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findById: async (subdomainAndRegion, id, options = {}) => {
            // verify required parameter 'subdomainAndRegion' is not null or undefined
            (0, common_1.assertParamExists)('findById', 'subdomainAndRegion', subdomainAndRegion);
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('findById', 'id', id);
            const localVarPath = `/v1/hosted-widget/{subdomainAndRegion}/{id}`
                .replace(`{${"subdomainAndRegion"}}`, encodeURIComponent(String(subdomainAndRegion)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} subdomainAndRegion Subdomain and region separated by hyphen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDefault: async (subdomainAndRegion, options = {}) => {
            // verify required parameter 'subdomainAndRegion' is not null or undefined
            (0, common_1.assertParamExists)('findDefault', 'subdomainAndRegion', subdomainAndRegion);
            const localVarPath = `/v1/hosted-widget/{subdomainAndRegion}`
                .replace(`{${"subdomainAndRegion"}}`, encodeURIComponent(String(subdomainAndRegion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.HostedWidgetApiAxiosParamCreator = HostedWidgetApiAxiosParamCreator;
/**
 * HostedWidgetApi - functional programming interface
 * @export
 */
const HostedWidgetApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.HostedWidgetApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} subdomainAndRegion Subdomain and region separated by hyphen
         * @param {string} id Widget ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findById(subdomainAndRegion, id, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.findById(subdomainAndRegion, id, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['HostedWidgetApi.findById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} subdomainAndRegion Subdomain and region separated by hyphen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findDefault(subdomainAndRegion, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.findDefault(subdomainAndRegion, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['HostedWidgetApi.findDefault']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.HostedWidgetApiFp = HostedWidgetApiFp;
/**
 * HostedWidgetApi - factory interface
 * @export
 */
const HostedWidgetApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.HostedWidgetApiFp)(configuration);
    return {
        /**
         *
         * @param {HostedWidgetApiFindByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findById(requestParameters, options) {
            return localVarFp.findById(requestParameters.subdomainAndRegion, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {HostedWidgetApiFindDefaultRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDefault(requestParameters, options) {
            return localVarFp.findDefault(requestParameters.subdomainAndRegion, options).then((request) => request(axios, basePath));
        },
    };
};
exports.HostedWidgetApiFactory = HostedWidgetApiFactory;
/**
 * HostedWidgetApi - object-oriented interface
 * @export
 * @class HostedWidgetApi
 * @extends {BaseAPI}
 */
class HostedWidgetApi extends base_1.BaseAPI {
    /**
     *
     * @param {HostedWidgetApiFindByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HostedWidgetApi
     */
    findById(requestParameters, options) {
        return (0, exports.HostedWidgetApiFp)(this.configuration).findById(requestParameters.subdomainAndRegion, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {HostedWidgetApiFindDefaultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HostedWidgetApi
     */
    findDefault(requestParameters, options) {
        return (0, exports.HostedWidgetApiFp)(this.configuration).findDefault(requestParameters.subdomainAndRegion, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.HostedWidgetApi = HostedWidgetApi;
/**
 * LocationApi - axios parameter creator
 * @export
 */
const LocationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} countryName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryCode: async (countryName, options = {}) => {
            // verify required parameter 'countryName' is not null or undefined
            (0, common_1.assertParamExists)('getCountryCode', 'countryName', countryName);
            const localVarPath = `/v1/locations/codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (countryName !== undefined) {
                localVarQueryParameter['countryName'] = countryName;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} countryCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegions: async (countryCode, options = {}) => {
            // verify required parameter 'countryCode' is not null or undefined
            (0, common_1.assertParamExists)('getRegions', 'countryCode', countryCode);
            const localVarPath = `/v1/locations/regions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (countryCode !== undefined) {
                localVarQueryParameter['countryCode'] = countryCode;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationSuggestions: async (xPartnerCode, options = {}) => {
            // verify required parameter 'xPartnerCode' is not null or undefined
            (0, common_1.assertParamExists)('locationSuggestions', 'xPartnerCode', xPartnerCode);
            const localVarPath = `/v1/locations/suggest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xPartnerCode != null) {
                localVarHeaderParameter['x-partner-code'] = String(xPartnerCode);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.LocationApiAxiosParamCreator = LocationApiAxiosParamCreator;
/**
 * LocationApi - functional programming interface
 * @export
 */
const LocationApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.LocationApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} countryName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountryCode(countryName, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountryCode(countryName, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LocationApi.getCountryCode']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} countryCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegions(countryCode, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegions(countryCode, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LocationApi.getRegions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationSuggestions(xPartnerCode, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationSuggestions(xPartnerCode, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LocationApi.locationSuggestions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.LocationApiFp = LocationApiFp;
/**
 * LocationApi - factory interface
 * @export
 */
const LocationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.LocationApiFp)(configuration);
    return {
        /**
         *
         * @param {LocationApiGetCountryCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryCode(requestParameters, options) {
            return localVarFp.getCountryCode(requestParameters.countryName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {LocationApiGetRegionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegions(requestParameters, options) {
            return localVarFp.getRegions(requestParameters.countryCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {LocationApiLocationSuggestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationSuggestions(requestParameters, options) {
            return localVarFp.locationSuggestions(requestParameters.xPartnerCode, options).then((request) => request(axios, basePath));
        },
    };
};
exports.LocationApiFactory = LocationApiFactory;
/**
 * LocationApi - object-oriented interface
 * @export
 * @class LocationApi
 * @extends {BaseAPI}
 */
class LocationApi extends base_1.BaseAPI {
    /**
     *
     * @param {LocationApiGetCountryCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    getCountryCode(requestParameters, options) {
        return (0, exports.LocationApiFp)(this.configuration).getCountryCode(requestParameters.countryName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LocationApiGetRegionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    getRegions(requestParameters, options) {
        return (0, exports.LocationApiFp)(this.configuration).getRegions(requestParameters.countryCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LocationApiLocationSuggestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    locationSuggestions(requestParameters, options) {
        return (0, exports.LocationApiFp)(this.configuration).locationSuggestions(requestParameters.xPartnerCode, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.LocationApi = LocationApi;
/**
 * ProductApi - axios parameter creator
 * @export
 */
const ProductApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crossSelling: async (xPartnerCode, id, options = {}) => {
            // verify required parameter 'xPartnerCode' is not null or undefined
            (0, common_1.assertParamExists)('crossSelling', 'xPartnerCode', xPartnerCode);
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('crossSelling', 'id', id);
            const localVarPath = `/v1/products/{id}/cross-selling`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xPartnerCode != null) {
                localVarHeaderParameter['x-partner-code'] = String(xPartnerCode);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {boolean} [excludeValueVouchers] Value vouchers are included by default. You can exclude them with this parameter. Supported values: \&quot;true\&quot;, \&quot;false\&quot;.
         * @param {boolean} [includeInactive] Inactive products are excluded by default. You can include them with this parameter. Supported values: \&quot;true\&quot;, \&quot;false\&quot;.
         * @param {any} [lang] Locale for content translation
         * @param {string} [suitableFor] Comma-separated list of option values. Use \&quot;suitableFor\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint.
         * @param {string} [weather] Comma-separated list of option values. Use \&quot;weather\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint.
         * @param {string} [topThingsToDo] Comma-separated list of option values. Use \&quot;topThingsToDo\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint.
         * @param {string} [languages] Comma-separated list of language ids. Use \&quot;languages\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint as ids here.
         * @param {string} [categories] Comma-separated list of category ids. Use \&quot;categories\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint as ids here.
         * @param {string} [tags] Comma-separated list of reseller tag ids. Use \&quot;tags\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint as ids here.
         * @param {string} [maxPrice] Maximum price, a positive number without decimal digits
         * @param {string} [minPrice] Minimum price, a positive number without decimal digits
         * @param {string} [dateFrom] ISO date string in local time of the searched region; seconds and milliseconds are optional (&#x60;YYYY-MM-DDTHH:mm&#x60;).
         * @param {string} [dateTo] ISO date string in local time of the searched region; seconds and milliseconds are optional (&#x60;YYYY-MM-DDTHH:mm&#x60;)
         * @param {number} [radius] Radius around geolocation in meters. Positive integer. If defined, also &#x60;latitude&#x60; and &#x60;longitude&#x60; have to be specified
         * @param {any} [longitude] If defined, also &#x60;latitude&#x60; and &#x60;radius&#x60; have to be specified
         * @param {any} [latitude] If defined, also &#x60;longitude&#x60; and &#x60;radius&#x60; have to be specified
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterAttributes: async (xPartnerCode, excludeValueVouchers, includeInactive, lang, suitableFor, weather, topThingsToDo, languages, categories, tags, maxPrice, minPrice, dateFrom, dateTo, radius, longitude, latitude, options = {}) => {
            // verify required parameter 'xPartnerCode' is not null or undefined
            (0, common_1.assertParamExists)('filterAttributes', 'xPartnerCode', xPartnerCode);
            const localVarPath = `/v1/products/filter-attributes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (excludeValueVouchers !== undefined) {
                localVarQueryParameter['excludeValueVouchers'] = excludeValueVouchers;
            }
            if (includeInactive !== undefined) {
                localVarQueryParameter['includeInactive'] = includeInactive;
            }
            if (lang !== undefined) {
                for (const [key, value] of Object.entries(lang)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (suitableFor !== undefined) {
                localVarQueryParameter['suitableFor'] = suitableFor;
            }
            if (weather !== undefined) {
                localVarQueryParameter['weather'] = weather;
            }
            if (topThingsToDo !== undefined) {
                localVarQueryParameter['topThingsToDo'] = topThingsToDo;
            }
            if (languages !== undefined) {
                localVarQueryParameter['languages'] = languages;
            }
            if (categories !== undefined) {
                localVarQueryParameter['categories'] = categories;
            }
            if (tags !== undefined) {
                localVarQueryParameter['tags'] = tags;
            }
            if (maxPrice !== undefined) {
                localVarQueryParameter['maxPrice'] = maxPrice;
            }
            if (minPrice !== undefined) {
                localVarQueryParameter['minPrice'] = minPrice;
            }
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = dateTo;
            }
            if (radius !== undefined) {
                localVarQueryParameter['radius'] = radius;
            }
            if (longitude !== undefined) {
                for (const [key, value] of Object.entries(longitude)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (latitude !== undefined) {
                for (const [key, value] of Object.entries(latitude)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (xPartnerCode != null) {
                localVarHeaderParameter['x-partner-code'] = String(xPartnerCode);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {boolean} [excludeValueVouchers] Value vouchers are included by default. You can exclude them with this parameter. Supported values: \&quot;true\&quot;, \&quot;false\&quot;.
         * @param {boolean} [includeInactive] Inactive products are excluded by default. You can include them with this parameter. Supported values: \&quot;true\&quot;, \&quot;false\&quot;.
         * @param {any} [lang] Locale for content translation
         * @param {string} [suitableFor] Comma-separated list of option values. Use \&quot;suitableFor\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint.
         * @param {string} [weather] Comma-separated list of option values. Use \&quot;weather\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint.
         * @param {string} [topThingsToDo] Comma-separated list of option values. Use \&quot;topThingsToDo\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint.
         * @param {string} [languages] Comma-separated list of language ids. Use \&quot;languages\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint as ids here.
         * @param {string} [categories] Comma-separated list of category ids. Use \&quot;categories\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint as ids here.
         * @param {string} [tags] Comma-separated list of reseller tag ids. Use \&quot;tags\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint as ids here.
         * @param {string} [maxPrice] Maximum price, a positive number without decimal digits
         * @param {string} [minPrice] Minimum price, a positive number without decimal digits
         * @param {string} [dateFrom] ISO date string in local time of the searched region; seconds and milliseconds are optional (&#x60;YYYY-MM-DDTHH:mm&#x60;).
         * @param {string} [dateTo] ISO date string in local time of the searched region; seconds and milliseconds are optional (&#x60;YYYY-MM-DDTHH:mm&#x60;)
         * @param {number} [radius] Radius around geolocation in meters. Positive integer. If defined, also &#x60;latitude&#x60; and &#x60;longitude&#x60; have to be specified
         * @param {any} [longitude] If defined, also &#x60;latitude&#x60; and &#x60;radius&#x60; have to be specified
         * @param {any} [latitude] If defined, also &#x60;longitude&#x60; and &#x60;radius&#x60; have to be specified
         * @param {string} [keyword]
         * @param {number} [offset] The number of products you wish to skip before selecting. Default 0
         * @param {number} [limit] The maximum number of products that are returned after the offset. Maximum and default value: 250
         * @param {FindAllSortEnum} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (xPartnerCode, excludeValueVouchers, includeInactive, lang, suitableFor, weather, topThingsToDo, languages, categories, tags, maxPrice, minPrice, dateFrom, dateTo, radius, longitude, latitude, keyword, offset, limit, sort, options = {}) => {
            // verify required parameter 'xPartnerCode' is not null or undefined
            (0, common_1.assertParamExists)('findAll', 'xPartnerCode', xPartnerCode);
            const localVarPath = `/v1/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (excludeValueVouchers !== undefined) {
                localVarQueryParameter['excludeValueVouchers'] = excludeValueVouchers;
            }
            if (includeInactive !== undefined) {
                localVarQueryParameter['includeInactive'] = includeInactive;
            }
            if (lang !== undefined) {
                for (const [key, value] of Object.entries(lang)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (suitableFor !== undefined) {
                localVarQueryParameter['suitableFor'] = suitableFor;
            }
            if (weather !== undefined) {
                localVarQueryParameter['weather'] = weather;
            }
            if (topThingsToDo !== undefined) {
                localVarQueryParameter['topThingsToDo'] = topThingsToDo;
            }
            if (languages !== undefined) {
                localVarQueryParameter['languages'] = languages;
            }
            if (categories !== undefined) {
                localVarQueryParameter['categories'] = categories;
            }
            if (tags !== undefined) {
                localVarQueryParameter['tags'] = tags;
            }
            if (maxPrice !== undefined) {
                localVarQueryParameter['maxPrice'] = maxPrice;
            }
            if (minPrice !== undefined) {
                localVarQueryParameter['minPrice'] = minPrice;
            }
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = dateTo;
            }
            if (radius !== undefined) {
                localVarQueryParameter['radius'] = radius;
            }
            if (longitude !== undefined) {
                for (const [key, value] of Object.entries(longitude)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (latitude !== undefined) {
                for (const [key, value] of Object.entries(latitude)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (xPartnerCode != null) {
                localVarHeaderParameter['x-partner-code'] = String(xPartnerCode);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {boolean} [excludeValueVouchers] Value vouchers are included by default. You can exclude them with this parameter. Supported values: \&quot;true\&quot;, \&quot;false\&quot;.
         * @param {boolean} [includeInactive] Inactive products are excluded by default. You can include them with this parameter. Supported values: \&quot;true\&quot;, \&quot;false\&quot;.
         * @param {any} [lang] Locale for content translation
         * @param {string} [keyword]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllProductsForWidgetEditor: async (xPartnerCode, excludeValueVouchers, includeInactive, lang, keyword, options = {}) => {
            // verify required parameter 'xPartnerCode' is not null or undefined
            (0, common_1.assertParamExists)('findAllProductsForWidgetEditor', 'xPartnerCode', xPartnerCode);
            const localVarPath = `/v1/products-widget-editor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (excludeValueVouchers !== undefined) {
                localVarQueryParameter['excludeValueVouchers'] = excludeValueVouchers;
            }
            if (includeInactive !== undefined) {
                localVarQueryParameter['includeInactive'] = includeInactive;
            }
            if (lang !== undefined) {
                for (const [key, value] of Object.entries(lang)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }
            if (xPartnerCode != null) {
                localVarHeaderParameter['x-partner-code'] = String(xPartnerCode);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {string} id
         * @param {any} [lang] Locale for content translation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (xPartnerCode, id, lang, options = {}) => {
            // verify required parameter 'xPartnerCode' is not null or undefined
            (0, common_1.assertParamExists)('findOne', 'xPartnerCode', xPartnerCode);
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('findOne', 'id', id);
            const localVarPath = `/v1/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (lang !== undefined) {
                for (const [key, value] of Object.entries(lang)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (xPartnerCode != null) {
                localVarHeaderParameter['x-partner-code'] = String(xPartnerCode);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {string} id
         * @param {number} [limit] The maximum number of reviews that are returned after the offset. Default value: 10
         * @param {number} [offset] The number of reviews you wish to skip before selecting. Default 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviews: async (xPartnerCode, id, limit, offset, options = {}) => {
            // verify required parameter 'xPartnerCode' is not null or undefined
            (0, common_1.assertParamExists)('reviews', 'xPartnerCode', xPartnerCode);
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('reviews', 'id', id);
            const localVarPath = `/v1/products/{id}/reviews`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (xPartnerCode != null) {
                localVarHeaderParameter['x-partner-code'] = String(xPartnerCode);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ProductApiAxiosParamCreator = ProductApiAxiosParamCreator;
/**
 * ProductApi - functional programming interface
 * @export
 */
const ProductApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ProductApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crossSelling(xPartnerCode, id, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.crossSelling(xPartnerCode, id, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductApi.crossSelling']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {boolean} [excludeValueVouchers] Value vouchers are included by default. You can exclude them with this parameter. Supported values: \&quot;true\&quot;, \&quot;false\&quot;.
         * @param {boolean} [includeInactive] Inactive products are excluded by default. You can include them with this parameter. Supported values: \&quot;true\&quot;, \&quot;false\&quot;.
         * @param {any} [lang] Locale for content translation
         * @param {string} [suitableFor] Comma-separated list of option values. Use \&quot;suitableFor\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint.
         * @param {string} [weather] Comma-separated list of option values. Use \&quot;weather\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint.
         * @param {string} [topThingsToDo] Comma-separated list of option values. Use \&quot;topThingsToDo\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint.
         * @param {string} [languages] Comma-separated list of language ids. Use \&quot;languages\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint as ids here.
         * @param {string} [categories] Comma-separated list of category ids. Use \&quot;categories\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint as ids here.
         * @param {string} [tags] Comma-separated list of reseller tag ids. Use \&quot;tags\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint as ids here.
         * @param {string} [maxPrice] Maximum price, a positive number without decimal digits
         * @param {string} [minPrice] Minimum price, a positive number without decimal digits
         * @param {string} [dateFrom] ISO date string in local time of the searched region; seconds and milliseconds are optional (&#x60;YYYY-MM-DDTHH:mm&#x60;).
         * @param {string} [dateTo] ISO date string in local time of the searched region; seconds and milliseconds are optional (&#x60;YYYY-MM-DDTHH:mm&#x60;)
         * @param {number} [radius] Radius around geolocation in meters. Positive integer. If defined, also &#x60;latitude&#x60; and &#x60;longitude&#x60; have to be specified
         * @param {any} [longitude] If defined, also &#x60;latitude&#x60; and &#x60;radius&#x60; have to be specified
         * @param {any} [latitude] If defined, also &#x60;longitude&#x60; and &#x60;radius&#x60; have to be specified
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filterAttributes(xPartnerCode, excludeValueVouchers, includeInactive, lang, suitableFor, weather, topThingsToDo, languages, categories, tags, maxPrice, minPrice, dateFrom, dateTo, radius, longitude, latitude, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.filterAttributes(xPartnerCode, excludeValueVouchers, includeInactive, lang, suitableFor, weather, topThingsToDo, languages, categories, tags, maxPrice, minPrice, dateFrom, dateTo, radius, longitude, latitude, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductApi.filterAttributes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {boolean} [excludeValueVouchers] Value vouchers are included by default. You can exclude them with this parameter. Supported values: \&quot;true\&quot;, \&quot;false\&quot;.
         * @param {boolean} [includeInactive] Inactive products are excluded by default. You can include them with this parameter. Supported values: \&quot;true\&quot;, \&quot;false\&quot;.
         * @param {any} [lang] Locale for content translation
         * @param {string} [suitableFor] Comma-separated list of option values. Use \&quot;suitableFor\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint.
         * @param {string} [weather] Comma-separated list of option values. Use \&quot;weather\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint.
         * @param {string} [topThingsToDo] Comma-separated list of option values. Use \&quot;topThingsToDo\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint.
         * @param {string} [languages] Comma-separated list of language ids. Use \&quot;languages\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint as ids here.
         * @param {string} [categories] Comma-separated list of category ids. Use \&quot;categories\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint as ids here.
         * @param {string} [tags] Comma-separated list of reseller tag ids. Use \&quot;tags\&quot; attribute option values from &#x60;products/filter-attributes&#x60; endpoint as ids here.
         * @param {string} [maxPrice] Maximum price, a positive number without decimal digits
         * @param {string} [minPrice] Minimum price, a positive number without decimal digits
         * @param {string} [dateFrom] ISO date string in local time of the searched region; seconds and milliseconds are optional (&#x60;YYYY-MM-DDTHH:mm&#x60;).
         * @param {string} [dateTo] ISO date string in local time of the searched region; seconds and milliseconds are optional (&#x60;YYYY-MM-DDTHH:mm&#x60;)
         * @param {number} [radius] Radius around geolocation in meters. Positive integer. If defined, also &#x60;latitude&#x60; and &#x60;longitude&#x60; have to be specified
         * @param {any} [longitude] If defined, also &#x60;latitude&#x60; and &#x60;radius&#x60; have to be specified
         * @param {any} [latitude] If defined, also &#x60;longitude&#x60; and &#x60;radius&#x60; have to be specified
         * @param {string} [keyword]
         * @param {number} [offset] The number of products you wish to skip before selecting. Default 0
         * @param {number} [limit] The maximum number of products that are returned after the offset. Maximum and default value: 250
         * @param {FindAllSortEnum} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(xPartnerCode, excludeValueVouchers, includeInactive, lang, suitableFor, weather, topThingsToDo, languages, categories, tags, maxPrice, minPrice, dateFrom, dateTo, radius, longitude, latitude, keyword, offset, limit, sort, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(xPartnerCode, excludeValueVouchers, includeInactive, lang, suitableFor, weather, topThingsToDo, languages, categories, tags, maxPrice, minPrice, dateFrom, dateTo, radius, longitude, latitude, keyword, offset, limit, sort, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductApi.findAll']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {boolean} [excludeValueVouchers] Value vouchers are included by default. You can exclude them with this parameter. Supported values: \&quot;true\&quot;, \&quot;false\&quot;.
         * @param {boolean} [includeInactive] Inactive products are excluded by default. You can include them with this parameter. Supported values: \&quot;true\&quot;, \&quot;false\&quot;.
         * @param {any} [lang] Locale for content translation
         * @param {string} [keyword]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllProductsForWidgetEditor(xPartnerCode, excludeValueVouchers, includeInactive, lang, keyword, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllProductsForWidgetEditor(xPartnerCode, excludeValueVouchers, includeInactive, lang, keyword, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductApi.findAllProductsForWidgetEditor']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {string} id
         * @param {any} [lang] Locale for content translation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(xPartnerCode, id, lang, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(xPartnerCode, id, lang, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductApi.findOne']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} xPartnerCode The identity of the partner
         * @param {string} id
         * @param {number} [limit] The maximum number of reviews that are returned after the offset. Default value: 10
         * @param {number} [offset] The number of reviews you wish to skip before selecting. Default 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviews(xPartnerCode, id, limit, offset, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviews(xPartnerCode, id, limit, offset, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductApi.reviews']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.ProductApiFp = ProductApiFp;
/**
 * ProductApi - factory interface
 * @export
 */
const ProductApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ProductApiFp)(configuration);
    return {
        /**
         *
         * @param {ProductApiCrossSellingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crossSelling(requestParameters, options) {
            return localVarFp.crossSelling(requestParameters.xPartnerCode, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductApiFilterAttributesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterAttributes(requestParameters, options) {
            return localVarFp.filterAttributes(requestParameters.xPartnerCode, requestParameters.excludeValueVouchers, requestParameters.includeInactive, requestParameters.lang, requestParameters.suitableFor, requestParameters.weather, requestParameters.topThingsToDo, requestParameters.languages, requestParameters.categories, requestParameters.tags, requestParameters.maxPrice, requestParameters.minPrice, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.radius, requestParameters.longitude, requestParameters.latitude, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductApiFindAllRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(requestParameters, options) {
            return localVarFp.findAll(requestParameters.xPartnerCode, requestParameters.excludeValueVouchers, requestParameters.includeInactive, requestParameters.lang, requestParameters.suitableFor, requestParameters.weather, requestParameters.topThingsToDo, requestParameters.languages, requestParameters.categories, requestParameters.tags, requestParameters.maxPrice, requestParameters.minPrice, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.radius, requestParameters.longitude, requestParameters.latitude, requestParameters.keyword, requestParameters.offset, requestParameters.limit, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductApiFindAllProductsForWidgetEditorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllProductsForWidgetEditor(requestParameters, options) {
            return localVarFp.findAllProductsForWidgetEditor(requestParameters.xPartnerCode, requestParameters.excludeValueVouchers, requestParameters.includeInactive, requestParameters.lang, requestParameters.keyword, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductApiFindOneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(requestParameters, options) {
            return localVarFp.findOne(requestParameters.xPartnerCode, requestParameters.id, requestParameters.lang, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductApiReviewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviews(requestParameters, options) {
            return localVarFp.reviews(requestParameters.xPartnerCode, requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ProductApiFactory = ProductApiFactory;
/**
 * ProductApi - object-oriented interface
 * @export
 * @class ProductApi
 * @extends {BaseAPI}
 */
class ProductApi extends base_1.BaseAPI {
    /**
     *
     * @param {ProductApiCrossSellingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    crossSelling(requestParameters, options) {
        return (0, exports.ProductApiFp)(this.configuration).crossSelling(requestParameters.xPartnerCode, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductApiFilterAttributesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    filterAttributes(requestParameters, options) {
        return (0, exports.ProductApiFp)(this.configuration).filterAttributes(requestParameters.xPartnerCode, requestParameters.excludeValueVouchers, requestParameters.includeInactive, requestParameters.lang, requestParameters.suitableFor, requestParameters.weather, requestParameters.topThingsToDo, requestParameters.languages, requestParameters.categories, requestParameters.tags, requestParameters.maxPrice, requestParameters.minPrice, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.radius, requestParameters.longitude, requestParameters.latitude, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductApiFindAllRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    findAll(requestParameters, options) {
        return (0, exports.ProductApiFp)(this.configuration).findAll(requestParameters.xPartnerCode, requestParameters.excludeValueVouchers, requestParameters.includeInactive, requestParameters.lang, requestParameters.suitableFor, requestParameters.weather, requestParameters.topThingsToDo, requestParameters.languages, requestParameters.categories, requestParameters.tags, requestParameters.maxPrice, requestParameters.minPrice, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.radius, requestParameters.longitude, requestParameters.latitude, requestParameters.keyword, requestParameters.offset, requestParameters.limit, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductApiFindAllProductsForWidgetEditorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    findAllProductsForWidgetEditor(requestParameters, options) {
        return (0, exports.ProductApiFp)(this.configuration).findAllProductsForWidgetEditor(requestParameters.xPartnerCode, requestParameters.excludeValueVouchers, requestParameters.includeInactive, requestParameters.lang, requestParameters.keyword, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductApiFindOneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    findOne(requestParameters, options) {
        return (0, exports.ProductApiFp)(this.configuration).findOne(requestParameters.xPartnerCode, requestParameters.id, requestParameters.lang, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductApiReviewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    reviews(requestParameters, options) {
        return (0, exports.ProductApiFp)(this.configuration).reviews(requestParameters.xPartnerCode, requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ProductApi = ProductApi;
/**
  * @export
  * @enum {string}
  */
(function (FindAllSortEnum) {
    FindAllSortEnum["Distance"] = "distance";
    FindAllSortEnum["Price"] = "price";
    FindAllSortEnum["Price2"] = "-price";
})(FindAllSortEnum = exports.FindAllSortEnum || (exports.FindAllSortEnum = {}));
//# sourceMappingURL=api.js.map